import {LitElement, css, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { AlertId, VesselAlert, VesselAlertsModel } from '../../../src/models/vessel-alerts-model';

import "../../voyage-alert-message/src/voyage-alert-message";

@customElement('voy-alert-messages')
export class VoyAlertMessages extends LitElement {

    @property({type: Number})
    get imo(): number
    {
        return this._imo;
    }

    set imo(value: number)
    {
        const oldValue = this._imo;
        this._imo = value;
        this.requestUpdate('imo', oldValue);
        this._imoChanged();
    }

    constructor()
    {
        super();

        this._onAlertsChanged = this._onAlertsChanged.bind(this);
        this._onWeatherAlertsChanged = this._onWeatherAlertsChanged.bind(this);
    }

    static get styles()
    {
        return [
            css`
            :host {
                position: relative;
                margin-top: 5px;
                display: block;
            }

            voyage-alert-message {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
            }
            `
        ];
    }

    render()
    {
        return html`
        ${ this._alerts.map( (alert, index) => {
            const stackIndex = this._alerts.length - 1 - index;
            const pos = `top: ${stackIndex*5}px;left: ${stackIndex*5}px;right: ${stackIndex*5}px`

            return html`<voyage-alert-message .alert=${alert} message=${alert.message} display-count=${index+1} style=${pos} imo=${this.imo}
                        @close=${() => this._closeAlert(index)}
                        ></voyage-alert-message>`
        }) }
        `;
    }

    connectedCallback()
    {
        super.connectedCallback();
        if (this.imo)
        {
            this._alerts = VesselAlertsModel!.getAlerts(this.imo);
        }
        VesselAlertsModel!.addEventListener("alerts-changed", <EventListener>this._onAlertsChanged);
        VesselAlertsModel!.addEventListener("weather-alerts-changed", <EventListener>this._onWeatherAlertsChanged);
    }

    disconnectedCallback()
    {
        super.disconnectedCallback();
        VesselAlertsModel!.removeEventListener("alerts-changed", <EventListener>this._onAlertsChanged);
        VesselAlertsModel!.removeEventListener("weather-alerts-changed", <EventListener>this._onWeatherAlertsChanged);
    }

    @property({attribute: false}) private _alerts: VesselAlert[] = [];
    private _imo: number = 0;

    private _onAlertsChanged(evt: CustomEvent<{imo: number, alerts: VesselAlert[]}>)
    {
        if (this._imo === evt.detail.imo){
            this._alerts = evt.detail.alerts;
        }
        evt.detail?.alerts?.map((alert,index) => {
            if ( evt.detail.alerts[index]?.id?.includes(AlertId.HeavyWeather) || evt.detail.alerts[index]?.id?.includes(AlertId.ParametricRoll)){
                let existingAlert = this._alerts.find((a) => a.id === alert.id);
                if(!existingAlert) {
                    this._alerts = [...this._alerts,alert];
                }
            } 
        })
    }

    private _onWeatherAlertsChanged(evt: CustomEvent<{imo: number, alerts: VesselAlert[]}>){
            this._alerts = [ ...evt.detail.alerts];
        }


    private _imoChanged()
    {
        if (this._imo)
        {
            this._alerts = VesselAlertsModel!.getAlerts(this._imo);
        }
        else
        {
            this._alerts = [];
        }
    }

    private _closeAlert(index: number)
    {
        if (this._alerts.length > index)
        {
            if(this._alerts[index].id.includes(AlertId.HeavyWeather) || this._alerts[index].id.includes(AlertId.ParametricRoll)){
                VesselAlertsModel!.removeAlert(this._getImoFromAlert(index), this._alerts[index].id);
            }
            else {
                VesselAlertsModel!.removeAlert(this._imo, this._alerts[index].id);
            }
        }
    }

    private _getImoFromAlert(index: number): number {
        return parseInt(this._alerts[index].id.split("-")[2]);
    }
};
